import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of, Subject } from 'rxjs';

/**
 * AuthGuardService is used to check if the application can activate. The application
 * can only activate if the user is logged in. Otherwise, they are navigated to the login
 * screen
 */
@Injectable({
  providedIn: 'root'
})
export class AuthguardService {
  /**
   * Default constructor to initalize services 
   * 
   * @param _authService
   * @param _router 
   */
  constructor(
    private _authService: AuthService,
    private _router: Router,
  ) {

  }

  /**
   * Attempt to activate the application by checking authentication status
   * 
   * @returns status on if activation was successful
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    // If the token hasn't loaded, subscribe to the auth service to wait for it to load
    if (!this._authService.loadedToken) {
      console.log("[AUTHGUARD]: token not loaded, waiting for load")

      this._authService.authenticated$.subscribe({
        next: (isAuthenticated) => {
          console.log(isAuthenticated ? "[AUTHGUARD]: token loaded, user is authenticated" : "[AUTHGUARD]: token loaded, user is not authenticated");
          return of(isAuthenticated);
        }
      });
    }

    if (this._authService.isAuthenticated) {
      // User is authenticated, allow activation
      console.log("[AUTHGUARD]: user is authenticated")
      return of(true);
    } else {
      // User is not authenticated, navigate to login
      console.log(`[AUTHGUARD]: user not authenticated at '${this._router.url}', navigating to '/login'`)
      this._router.navigate(['/login']);
      return of(false);
    }
  }
}

